import instance from "@/services/api";

export const smetaChangeLogAPI = {
  async getRows(params) {
    return await instance()
      .get("/project/smeta_change_log/read/", { params })
      .then((res) => res?.data);
  },

  async getEntrances(sbs_project_id, project_id) {
    return await instance()
      .get("/project/smeta_change_log/entrances/", { params: { sbs_project_id, project_id } })
      .then((res) => res?.data);
  },

  async getFloors(sbs_project_id, project_entrance_id, project_id) {
    return await instance()
      .get("/project/smeta_change_log/floors/", {
        params: { sbs_project_id, project_entrance_id, project_id },
      })
      .then((res) => res?.data);
  },

  async getCheckGroups(sbs_project_id, project_entrance_id, floor_map_id, project_id) {
    return await instance()
      .get("/project/smeta_change_log/check_groups/", {
        params: { sbs_project_id, project_entrance_id, floor_map_id, project_id },
      })
      .then((res) => res?.data);
  },

  async deleteRows(smeta_change_log_ids) {
    return await instance()
      .post("/project/smeta_change_log/delete/", { smeta_change_log_ids })
      .then((res) => res?.data);
  },

  async getUspProjects() {
    return await instance()
      .get("/project/project_group/read/")
      .then((res) => res?.data);
  },
};
